export default __webpack_public_path__ + "static/media/notification_alert_icon.a35d2f1e.svg";